export default function dbconfig(dbname: string) {
  return {
    name: dbname,
    version: 2,
    objectStoresMeta: [
    ]
  };
}
